
export const getReduxState = () => require('../app/store').store.getState();
export const getReduxStore = () => require('../app/store').store;